import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'

import { t } from 'services/Translation'

import { ElementGroup } from '../../elements.types'
import { genElementConfig } from '../../genElementConfig'
import { ButtonDemo, ButtonDemoDisabled } from './ButtonDemo'
import ButtonElement from './ButtonElement'
import ButtonFormBrand from './ButtonFormBrand'
import { STYLE_FORM_SCHEMA } from './ButtonFormStyle'
import ButtonFormValue from './ButtonFormValue'
import buttonIcon from './assets/button.svg'

export default genElementConfig(CONFIG_ELEMENTS.button, {
  label: t('elements.button.label'),
  icon: buttonIcon,
  group: ElementGroup.view,
  styleFields: STYLE_FORM_SCHEMA,
  Element: ButtonElement,
  Demo: [ButtonDemo, ButtonDemoDisabled],
  FormValue: ButtonFormValue,
  FormBrand: ButtonFormBrand,
  EditorActions: null,
})
